import { t } from '@lingui/core/macro';
import type { ReactNode } from 'react';

import Remove from '@/assets/svg/remove.svg?react';
import { Button } from '@/components/buttons';
import { Link, Text } from '@/components/typography';
import { cn } from '@/lib/utils';

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  titleLink?: string;
  onRemove?: () => void;
};

const FitScoreTitleCell = ({ title, subtitle, titleLink, onRemove }: Props) => {
  return (
    <div className="relative flex flex-col items-center pl-7.5">
      {onRemove != null && (
        <Button
          variant="ghost"
          size="icon"
          shape="round"
          className={cn('absolute top-0 left-0 w-7 overflow-hidden')}
          onClick={onRemove}
          aria-label={t`Remove`}
        >
          <Remove
            className="hidden size-5 group-focus-within:block group-hover:block"
            width={20}
            height={20}
            aria-hidden
          />
        </Button>
      )}
      {titleLink ? (
        <Link variant="caption1" weight="bold" to={titleLink}>
          {title}
        </Link>
      ) : (
        <Text variant="caption1" weight="bold">
          {title}
        </Text>
      )}
      <Text variant="caption1">{subtitle}</Text>
    </div>
  );
};

export default FitScoreTitleCell;
